import { InitPage } from "../index";
import axios from "axios";
import swal from "sweetalert";

declare let assetsComponents: any;
declare let currentClientCode: string;
declare let currentStoreCode: string;

class AssetsComponents {
  selectedAssetsComponents = [];
  epcTagId = null;
  itemPrice = 0;
  showingModal = false;
  forceRefresh = false;
  rfidParentTagId = null;
  rfidParentItemNumber = null;
  rfidItemPrice = 0;
  rfidShowingModal = false;
  rfidForceRefresh = false;

  init() {
    const _this = this;
    $('#addAssetComponents').on('click', function() {
      _this.fetchCurrentItem($('#print_job_item_number').val());
      $(".addAssetComponents").modal('show');
    });

    $('#add-component').on('click', function() {
      _this.fetchItem($('#component-items').val());
      $('#print_job_force_save_to_inventory').prop('checked', true);
      $('#print_job_force_save_to_inventory').prop('disabled', true);
      $('input[name="print_job[force_save_to_inventory]"]').val(1);
    });

    $('#component-items').change('click', function() {
      if ($(this).val() != null) {
        $('#add-component').removeAttr('disabled');
      } else {
        $('#add-component').attr('disabled', 'disabled');
      }
    });

    $('.show_assets_components').on('click', function() {
      assetsComponents.selectedAssetsComponents = [];
      $('#asset-components-tbody').html('');
      assetsComponents.epcTagId = $(this).data('id');
      _this.fetchAssetsComponents(assetsComponents.epcTagId);
      assetsComponents.showingModal = true;
      $(".addAssetComponents").modal('show');
    });

    $('.show_rfid_assets_components').on('click', function() {
      assetsComponents.rfidParentTagId = $(this).data('id');
      assetsComponents.rfidParentItemNumber = null;
      assetsComponents.rfidShowingModal = true;
      assetsComponents.rfidForceRefresh = false;
      _this.fetchRfidAssetsComponents(assetsComponents.rfidParentTagId);
      $(".addRfidAssetComponents").modal('show');
    });

    $('#print_job_item_number').change(function() {
      $('#addAssetComponents').prop('class', '');
      assetsComponents.selectedAssetsComponents = [];
      $('#asset-components-tbody').html('');
      $('#print_job_assets_components').val('');
    });

    $('.select-item').on('click', function() {
      $('#addAssetComponents').prop('class', '');
      assetsComponents.selectedAssetsComponents = [];
      $('#asset-components-tbody').html('');
      $('#print_job_assets_components').val('');
    });

    $('#assetComponentsCloseModal').on('click', function() {
      if (assetsComponents.forceRefresh) {
        window.location.reload();
      }
    });

    $('#rfid-component-items').change('click', function() {
      if ($(this).val() != null) {
        $('#add-rfid-component').removeAttr('disabled');
      } else {
        $('#add-rfid-component').attr('disabled', 'disabled');
      }
    });

    $('#add-rfid-component').on('click', function() {
      const selectedItemNumber = $('#rfid-component-items').val();
      if (selectedItemNumber == null || assetsComponents.rfidParentTagId == null) {
        return;
      }
      _this.createRfidAssetComponent(assetsComponents.rfidParentTagId, selectedItemNumber as string);
    });

    $('#rfidAssetComponentsCloseModal').on('click', function() {
      if (assetsComponents.rfidForceRefresh) {
        window.location.reload();
      }
    });

    $('.addRfidAssetComponents').on('hidden.bs.modal', function() {
      $(this).find('[data-toggle="popover"]').each(function() {
        ($(this) as any).popover('hide');
        ($(this) as any).popover('dispose');
      });
      $('.popover').remove();
    });

  }

  initializeHTML() {
    $(document).ready(function() {
      const _this = this;
      $('.component_items').select2({
        allowClear: true,
        width: '100%',
        ajax: {
          url: `/${currentClientCode}/items/search.json`,
          data: function(params) {
            var query = {
              number: params.term,
              search_types: ['number', 'description', 'sku', 'alu'],
              undiscard: true
            }
            return query;
          },
          processResults: function(data) {
            const filteredData = data.filter((item) => item.number !== assetsComponents.rfidParentItemNumber);
            return {
              results: filteredData.map(function(item) {
                var text = item.number;
                if (item.sku != null && item.sku != '') {
                  text = `${text} - ${item.sku}`;
                }
                if (item.description != null && item.description != '') {
                  text = `${text} - ${item.description}`;
                }
                if (item.alu != null && item.alu != '') {
                  text = `${text} - ${item.alu}`;
                }
                if (item.upc != null && item.upc != '') {
                  text = `${text} - ${item.upc}`;
                }

                return {
                  id: item.number,
                  text: text
                }
              })
            };
          }
        },
        dropdownParent: $(".addAssetComponents"),
        templateSelection: _this.updateItemMetadata
      });

      $('.rfid_component_items').select2({
        allowClear: true,
        width: '100%',
        ajax: {
          url: `/${currentClientCode}/items/search.json`,
          data: function(params) {
            var query = {
              number: params.term,
              search_types: ['number', 'description', 'sku', 'alu'],
              undiscard: true
            }
            return query;
          },
          processResults: function(data) {
            return {
              results: data.map(function(item) {
                var text = item.number;
                if (item.sku != null && item.sku != '') {
                  text = `${text} - ${item.sku}`;
                }
                if (item.description != null && item.description != '') {
                  text = `${text} - ${item.description}`;
                }
                if (item.alu != null && item.alu != '') {
                  text = `${text} - ${item.alu}`;
                }
                if (item.upc != null && item.upc != '') {
                  text = `${text} - ${item.upc}`;
                }

                return {
                  id: item.number,
                  text: text
                }
              })
            };
          }
        },
        dropdownParent: $(".addRfidAssetComponents"),
        templateSelection: _this.updateItemMetadata
      });
    });
  }

  updateItemMetadata(e) {
    return e.text;
  }

  fetchCurrentItem(item_number) {
    const _this = this;
    axios.get(`/${currentClientCode}/items/${item_number}.json`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      var currentItemTitle = response.data.number;
      if (response.data.description != null) {
        currentItemTitle = `${response.data.number} - ${response.data.description}`;
      }
      $('#assetComponentsItemNumber').html(currentItemTitle);
      $('#assetComponentsItemPrice').html(`$${response.data.retail_price}`);
      if (assetsComponents.selectedAssetsComponents.length === 0) {
        $('#assetComponentsItemTotalPrice').html(`$${response.data.retail_price}`);
        assetsComponents.itemPrice = parseFloat(response.data.retail_price);
      }
    }).catch(function(error) {
      window.toastr_notifications.error(error, "Error");
    });
  }

  fetchItem(item_number) {
    const _this = this;
    axios.get(`/${currentClientCode}/items/${item_number}.json`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      if (assetsComponents.selectedAssetsComponents.includes(response.data.number)) {
        return;
      }
      _this.appendItem(response.data);
      assetsComponents.selectedAssetsComponents.push(response.data.number);
      $('#print_job_assets_components').val(assetsComponents.selectedAssetsComponents.join(','));
      if (assetsComponents.epcTagId != null) {
        _this.updateAssetsComponents();
      }
    }).catch(function(error) {
      window.toastr_notifications.error(error, "Error");
    });
  }

  fetchAssetsComponents(epc_tag_id) {
    assetsComponents.itemPrice = 0;
    $('#asset-components-tbody').html('');
    assetsComponents.selectedAssetsComponents = [];
    const _this = this;
    axios.get(`/${currentClientCode}/${currentStoreCode}/epc_tags/${epc_tag_id}/assets_components.json`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      response.data.assets_components.forEach((item) => {
        _this.appendItem(item);
        assetsComponents.selectedAssetsComponents.push(item.number);
      });

      assetsComponents.itemPrice += parseFloat(response.data.item_retail_price);
      $('#assetComponentsItemTotalPrice').html(`$${assetsComponents.itemPrice.toFixed(2)}`);
      $('#assetComponentsItemPrice').html(`$${response.data.item_retail_price}`);
      var currentItemTitle = response.data.item_number;
      if (response.data.item_name != null) {
        currentItemTitle = `${response.data.item_number} - ${response.data.item_name}`;
      }
      $('#assetComponentsItemNumber').html(currentItemTitle);
    }).catch(function(error) {
      window.toastr_notifications.error(error, "Error");
    });
  }

  appendItem(item) {
    $('#asset-components-tbody').append(`
            <tr class='center-content components' data-id="${item.number}" id="component${item.number}">
                <td>${item.number || ''}</td>
                <td>${item.alu || ''}</td>
                <td>${item.sku || ''}</td>
                <td style="text-align: left !important" title="${item.description || ''}">${item.description != null ? item.description.substring(0, 40) : ''}</td>
                <td>${item.retail_price != null ? '$' + item.retail_price : ''}</td>
                <td class='sn-icons'>
                    <a href='#' class='fa fa-minus-circle fa-2x delete-icon' onclick="assetsComponents.removeItem('${item.number}', ${item.retail_price})" title='Delete' toggle='tooltip'></a>
                </td>
            </tr>
        `);
    assetsComponents.itemPrice += parseFloat(item.retail_price);
    $('#assetComponentsItemTotalPrice').html(`$${assetsComponents.itemPrice.toFixed(2)}`);
  }

  removeItem(item_number, retail_price) {
    swal({
      title: "Are you sure?",
      text: "This operation will delete the item!",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-danger",
          closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      if (isConfirmed) {
        $(`#component${item_number}`).hide();
        assetsComponents.selectedAssetsComponents.pop(item_number);
        if (assetsComponents.epcTagId != null) {
          this.updateAssetsComponents();
        }
        assetsComponents.itemPrice -= retail_price;
        $('#assetComponentsItemTotalPrice').html(`$${assetsComponents.itemPrice.toFixed(2)}`);
        if (assetsComponents.showingModal == true) {
          assetsComponents.forceRefresh = true;
        }
      }
    });
  }

  updateAssetsComponents() {
    const _this = this;
    axios.put(`/${currentClientCode}/${currentStoreCode}/epc_tags/${assetsComponents.epcTagId}.json`, {
      epc_tag: {
        components: assetsComponents.selectedAssetsComponents
      }
    }, {
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).then(function(response) {
      if (assetsComponents.showingModal == true) {
        assetsComponents.forceRefresh = true;
      }
    }).catch(function(error) {
      window.toastr_notifications.error(error, "Error");
    });
  }

  fetchRfidAssetsComponents(epc_tag_id) {
    assetsComponents.rfidItemPrice = 0;
    $('#rfid-asset-components-tbody').html('');
    const _this = this;
    axios.get(`/${currentClientCode}/${currentStoreCode}/epc_tags/${epc_tag_id}/rfid_assets_components.json`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      response.data.rfid_assets_components.forEach((tag) => {
        _this.appendRfidItem(tag);
      });

      assetsComponents.rfidItemPrice += parseFloat(response.data.item_retail_price);
      $('#rfidAssetComponentsItemTotalPrice').html(`$${assetsComponents.rfidItemPrice.toFixed(2)}`);
      $('#rfidAssetComponentsItemPrice').html(`$${response.data.item_retail_price}`);
      var currentItemTitle = response.data.item_number;
      assetsComponents.rfidParentItemNumber = response.data.item_number;
      if (response.data.item_name != null) {
        currentItemTitle = `${response.data.item_number} - ${response.data.item_name}`;
      }
      $('#rfidAssetComponentsItemNumber').html(currentItemTitle);
    }).catch(function(error) {
      window.toastr_notifications.error(error, "Error");
    });
  }

  createRfidAssetComponent(parentTagId, itemNumber) {
    const _this = this;
    axios.post(`/${currentClientCode}/${currentStoreCode}/epc_tags/${parentTagId}/create_rfid_asset_component.json`, {
      item_number: itemNumber
    }, {
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).then(function(response) {
      _this.appendRfidItem(response.data);
      assetsComponents.rfidForceRefresh = true;
    }).catch(function(error) {
      window.toastr_notifications.error(error.response?.data?.error || error, "Error");
    });
  }

  appendRfidItem(tag) {
    const item = tag.item || {};
    const retailPriceSource = item.retail_price != null ? item.retail_price : tag.retail_price;
    const parsedRetailPrice = parseFloat(retailPriceSource);
    const unitPrice = Number.isNaN(parsedRetailPrice) ? 0 : parsedRetailPrice;
    const rowId = `rfidComponent${tag.id}`;
    const showContainerQty = $('.addRfidAssetComponents').data('enable-storage-unit') === true || $('.addRfidAssetComponents').data('enable-storage-unit') === 'true';
    const parsedContainerQty = parseInt(tag.current_units, 10);
    const containerQty = Number.isNaN(parsedContainerQty) ? 1 : parsedContainerQty;
    const tagPrice = unitPrice * containerQty;
    $('#rfid-asset-components-tbody').append(`
      <tr class='center-content rfid-components' data-id="${tag.id}" id="${rowId}">
        <td>${tag.item_number || ''}</td>
        <td>${tag.asset_id || ''}</td>
        <td>${item.alu || tag.alu || ''}</td>
        <td>${item.sku || tag.sku || ''}</td>
        <td style="text-align: left !important" title="${item.description || tag.description || ''}">${(item.description || tag.description || '').substring(0, 40)}</td>
        <td>$${tagPrice.toFixed(2)}</td>
        ${showContainerQty ? `<td>${containerQty}</td>` : ''}
        <td>${tag.status_name || '-'}</td>
        <td class='sn-icons'>
          <i
            class="fa fa-tags pointer text-primary hover-cursor-pointer"
            data-toggle="popover"
            data-placement="top"
            data-content="EPC: ${tag.epc_id || '-'} \n Serial #: ${tag.asset_id || '-'}"
            title="Tag Information"
          ></i>
        </td>
        <td class='sn-icons'>
          <a href='#' class='fa fa-minus-circle delete-icon' onclick="assetsComponents.removeRfidItem(${tag.id}, ${tagPrice})" title='Delete' toggle='tooltip'></a>
          &nbsp;
          <a href='/${currentClientCode}/${currentStoreCode}/item_details/${tag.id}' class='fa fa-eye text-info' title='View Child Tag' target='_blank'></a>
        </td>
      </tr>
    `);
    $(`#${rowId} [data-toggle="popover"]`).popover({
      trigger: 'click',
      container: 'body'
    });
    assetsComponents.rfidItemPrice += tagPrice;
    $('#rfidAssetComponentsItemTotalPrice').html(`$${assetsComponents.rfidItemPrice.toFixed(2)}`);
  }

  removeRfidItem(componentTagId, tagPrice) {
    swal({
      title: "Are you sure?",
      text: "This operation will delete the RFID component tag!",
      icon: "warning",
      buttons: {
        cancel: {
          text: "No",
          value: false,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-silver",
          closeModal: true
        },
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "sn-btn sn-btn-sm sn-btn-danger",
          closeModal: true
        }
      },
      dangerMode: true
    }).then((isConfirmed) => {
      if (!isConfirmed || assetsComponents.rfidParentTagId == null) {
        return;
      }
      axios.delete(`/${currentClientCode}/${currentStoreCode}/epc_tags/${assetsComponents.rfidParentTagId}/remove_rfid_asset_component.json`, {
        data: { component_id: componentTagId },
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      }).then(() => {
        $(`#rfidComponent${componentTagId}`).remove();
        assetsComponents.rfidItemPrice -= tagPrice;
        $('#rfidAssetComponentsItemTotalPrice').html(`$${assetsComponents.rfidItemPrice.toFixed(2)}`);
        assetsComponents.rfidForceRefresh = true;
      }).catch((error) => {
        window.toastr_notifications.error(error.response?.data?.error || error, "Error");
      });
    });
  }
}

declare global {
  interface Window {
    AssetsComponents: AssetsComponents;
  }
}

export function LoadPage() {
  InitPage("print_v2", () => {
    const assetsComponents = new AssetsComponents();
    assetsComponents.init();
    assetsComponents.initializeHTML();
  });

  InitPage("item_group", () => {
    const assetsComponents = new AssetsComponents();
    assetsComponents.init();
    assetsComponents.initializeHTML();
  });

  InitPage("item_details", () => {
    const assetsComponents = new AssetsComponents();
    assetsComponents.init();
    assetsComponents.initializeHTML();
  });
}

(window as any).assetsComponents = new AssetsComponents();
